"use strict";
/*
 * Created on 01 21 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../utils/ObjectUtils");

var AdtFlag_1 = require("../AdtFlag");
/**
 * Base class for types of {@link EntityEvent entity events}.
 *
 * @author JMe
 * @author Radek Beran
 */


var EntityEventFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(EntityEventFlag, _AdtFlag_1$AdtFlag);

  function EntityEventFlag() {
    _classCallCheck(this, EntityEventFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityEventFlag).apply(this, arguments));
  }

  _createClass(EntityEventFlag, [{
    key: "equals",
    // See https://immutable-js.github.io/immutable-js/docs/#/is

    /**
     * @inheritDoc
     */
    value: function equals(other) {
      if (other instanceof EntityEventFlag) {
        return this.tag === other.tag;
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.tag);
    }
  }], [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(EntityEventFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(EntityEventFlag, data);
    }
  }]);

  return EntityEventFlag;
}(AdtFlag_1.AdtFlag);

exports.EntityEventFlag = EntityEventFlag;
EntityEventFlag.TAG = '__EntityEventFlag__'; // do not declare specific event types here, use specific application module